import { IBrowserPlatform, injectKVStorage, useBrowser, useKVState } from '@monofe/util';

export const useStateHasShown = (): [boolean, (newValue: boolean) => void] =>
    useKVState<boolean>('InstallBannerShown', Promise.resolve(injectKVStorage()), false);

export function useNeedsPopUp(): boolean {
    const browser = useBrowser();
    return browser?.platform === IBrowserPlatform.MobileiOS && !browser.isInstalled;
}
